const state = {
  requests: [],
  thread: null,
  threadMessages: []
};

export default state;
